export default __webpack_public_path__ + "static/media/logo24.8cb1fd4a.svg";